var styles = {
  "DraggableRegion": "Online-Store-UI-DraggableRegion_1t3d1",
  "hasBackgroundSheet": "Online-Store-UI-DraggableRegion--hasBackgroundSheet_8zmtc",
  "showBackgroundSheet": "Online-Store-UI-DraggableRegion--showBackgroundSheet_cjjz6",
  "fullCollapse": "Online-Store-UI-DraggableRegion--fullCollapse_1bkrp",
  "dragging": "Online-Store-UI-DraggableRegion--dragging_rfaw8",
  "expanded": "Online-Store-UI-DraggableRegion--expanded_6ocp6",
  "DragHandle": "Online-Store-UI-DraggableRegion__DragHandle_20mwo",
  "reducedHeightDragHandle": "Online-Store-UI-DraggableRegion--reducedHeightDragHandle_1hbhg",
  "Content": "Online-Store-UI-DraggableRegion__Content_4tswm",
  "scrollable": "Online-Store-UI-DraggableRegion--scrollable_kbgi9",
  "ContentInterior": "Online-Store-UI-DraggableRegion__ContentInterior_1gfdz",
  "isModal": "Online-Store-UI-DraggableRegion--isModal_ko94k",
  "exiting": "Online-Store-UI-DraggableRegion--exiting_dqhrc"
};

export { styles as default };
